import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Badge } from '@amzn/dui-react';
import styled from '@emotion/styled';
import { rio } from '@amzn/rio-design-tokens';
import { DealBadgePopover } from 'src/pages/productDetailsPage/components/dealsBadge/DealBadgePopover';
const BadgeWrapper = styled.div `
  display: flex;
  align-items: center;
  column-gap: ${rio.semantic.size.space.medium};
  color: ${({ theme }) => theme.rio.semantic.color.font.secondary};
`;
/**
 * Overrides internal Badge styles to match the Amazon retail deal badge
 * (`#dealBadge_feature_div .dealBadge`): bold ~14px pill with 4px 8px padding,
 * 4px radius, sitting inline with a small bottom margin.
 */
const BadgePill = styled.div `
  display: inline-block;
  vertical-align: middle;
  margin-bottom: ${rio.semantic.size.space.small};

  [data-component='dui-badge'] > div[role='presentation']:first-child {
    padding: ${rio.semantic.size.space.small} ${rio.semantic.size.space.medium};
    border-radius: ${rio.semantic.size.radius.small};
    font-weight: ${rio.semantic.fontWeight.bold};
    font-size: ${rio.semantic.size.font.small};
    font-family: ${rio.semantic.fontFamily.default};
    line-height: 20px;
  }
`;
/**
 * Maps Model DealBadgeRichContentFragment[] to the RichContent shape expected by DiscountsUI Badge.
 * Only text and countdownTimer fragment types are supported by  HandshakePainterModel.
 */
const toRichContent = (fragments) => {
    if (!fragments || fragments.length === 0)
        return undefined;
    // Badge expects a FragmentList ({ fragments: Fragment[] }) or a single Fragment.
    // We map each DealBadgeRichContentFragment to the appropriate shape.
    return {
        fragments: fragments.map((f) => {
            var _a;
            if (f.countdownTimer) {
                return { countdownTimer: { targetTime: f.countdownTimer.targetTime } };
            }
            return { text: (_a = f.text) !== null && _a !== void 0 ? _a : '' };
        }),
    };
};
export const DealsBadge = ({ dealBadge, dealDetails, locale, marketplaceId, showTermsInfo, }) => {
    if (!dealBadge)
        return null;
    const { label, messaging } = dealBadge;
    const endTime = dealDetails === null || dealDetails === void 0 ? void 0 : dealDetails.endTime;
    // messaging and label can each be absent on the wire, so guard the dereferences.
    // Use messaging.content if non-empty, otherwise fall back to label.content
    const messagingContent = (messaging === null || messaging === void 0 ? void 0 : messaging.content) && messaging.content.length > 0 ? messaging.content : label === null || label === void 0 ? void 0 : label.content;
    const content = toRichContent(messagingContent);
    if (!content)
        return null;
    const badgeMessage = {
        content: content,
        shortContent: toRichContent(messaging === null || messaging === void 0 ? void 0 : messaging.shortContent),
        color: label === null || label === void 0 ? void 0 : label.experimentalColor,
        backgroundColor: label === null || label === void 0 ? void 0 : label.experimentalBackgroundColor,
    };
    return (_jsxs(BadgeWrapper, { "data-testid": "deal-badge-section", children: [_jsx(BadgePill, { children: _jsx(Badge, { "data-testid": "deal-badge", label: badgeMessage, locale: locale, marketplaceId: marketplaceId }) }), showTermsInfo && endTime && _jsx(DealBadgePopover, { endTime: endTime, locale: locale })] }));
};
